// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"78df7f207f432a22062f","3093":"33b2b77f21490c6cfefb","3180":"d470f8fc3f4caa3772c7"}[chunkId] + ".css";
};